// extracted by mini-css-extract-plugin
module.exports = {"flag":"styles_flag__1cZxo"};